export default __webpack_public_path__ + "static/media/check-icon.e2b2e073.svg";